module.exports = __webpack_public_path__ + "img/center-guide.633c5166.svg";